import React, { FC, useState } from 'react';

import { Box, Stack } from '@mui/material';

import { DialogModal } from '../../components';
import { UserRole } from '../../types/user.types';
import { metaTitle } from '../../util/tabTitle';
import { useIsUserRole } from '../../util/useIsUserRole';
import { CategoryForm } from './CategoryForm';
import CategoryTable from './CategoryTable';
import Breadcrumbs from '../../components/Breadcrumb';
import {
  ManagementPageHeader,
  ManagementToolbar,
  RefreshAction,
} from '../../components/ManagementPageLayout';

const CategoryPage: FC = () => {
  metaTitle('Categories');
  const [open, setOpen] = useState(false);

  const disableAddNew = useIsUserRole([
    UserRole.user,
    UserRole.layoutEditor,
    UserRole.dataEditor,
  ]);

  const [refresh, setRefresh] = useState(false);

  return (
    <Box sx={{ width: '100%', maxWidth: 1360, mx: 'auto' }}>
      <Breadcrumbs
        items={[
          { label: 'Presentations', to: '/presentations' },
          {
            label: 'Categories',
            to: '/categories',
            description:
              'This page displays all the categories available for classifying presentations. Categories allow users to easily filter presentations in the presentations list based on their classification.',
          },
        ]}
      />
      <ManagementPageHeader
        title="Manage categories"
        subtitle="Organize presentations with reusable categories."
        actionLabel="New category"
        onAction={() => setOpen(true)}
        actionDisabled={disableAddNew}
      />
      <ManagementToolbar>
        <Box />
        <Stack direction="row" justifyContent="flex-end">
          <RefreshAction onClick={() => setRefresh(!refresh)} />
        </Stack>
      </ManagementToolbar>
      <CategoryTable onRefresh={refresh} />
      <DialogModal
        title="New category"
        onClose={() => setOpen(false)}
        open={open}
      >
        <CategoryForm onFinished={() => setOpen(false)} />
      </DialogModal>
    </Box>
  );
};

export default CategoryPage;
